import React, { useState } from "react";
import "react-responsive-modal/styles.css";
import { useSelector } from "react-redux";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { RootState } from "../reducers";
import GenericBeppoModal from "./general/genericBeppoModal";

interface EvidencePhotosModalProps {
  onClose: () => void;
  open: boolean;
  title: string;
}

const EvidencePhotosModal = (props: EvidencePhotosModalProps) => {
  const ticket = useSelector((state: RootState) => state.ticket.ticket);

  const [media] = useState(() => {
    if (ticket.imageUrls && ticket.imageUrls.length > 0) { // Backend will return imageUrls and videoUrls only with evidence key provided
      const imageUrls = ticket.imageUrls || [];
      const videoUrls = ticket.videoUrls || [];
      return [...imageUrls, ...videoUrls];
    } else {
      return ticket.blurredImageUrls || [];
    }
  });


  const videoThumbnail =
  // Base64 SVG thumbnail fallback for video files
    "data:image/svg+xml;base64," +
    btoa(`
      <svg xmlns='http://www.w3.org/2000/svg' width='200' height='120' viewBox='0 0 200 120'>
        <rect width='200' height='120' fill='black'/>
        <polygon points='80,40 140,60 80,80' fill='white'/>
      </svg>
    `);

  const mapMediaToGalleryItems = () => {
    return media.map((item) => {
      const isVideo = item.endsWith(".mp4") || item.endsWith(".webm");

      return {
        original: item,
        thumbnail: isVideo ? videoThumbnail : item,
        renderItem: () => {
          if (isVideo) {
            return (
              <div
                style={{
                  width: "100%",
                  height: "80vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#000",
                }}
              >
                <video
                  controls
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                  }}
                  src={item}
                />
              </div>
            );
          } else {
            return <img src={item} alt="" style={{ width: "100%" }} />;
          }
        },
      };
    });
  };

  return (
    <GenericBeppoModal
      title={props.title}
      open={props.open}
      onClose={props.onClose}
    >
      <ImageGallery
        items={mapMediaToGalleryItems()}
        showPlayButton={false}
        lazyLoad={true}
      />
    </GenericBeppoModal>
  );
};

export default EvidencePhotosModal;
